import React from 'react';
import styled from 'styled-components';
import IndicatorBox from '../../../../components/IndicatorBox';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';

const KeyIndicatorsCardContainer = styled.div`
  display: grid;
  .recapIndicatorsContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    .recapIndicatorsContainer {
      grid-template-columns: 1fr;
    }
  }
`;

// eslint-disable-next-line react/display-name
const KeyIndicatorCard = React.memo(function ({ indicators, title }) {
  return (
    <KeyIndicatorsCardContainer>
      <Card>
        <CardHeader title={title} fontSize="20px" iconRight />
        <div className="recapIndicatorsContainer">
          {indicators.map((indicator, index) => (
            <IndicatorBox key={index} {...indicator} />
          ))}
        </div>
      </Card>
    </KeyIndicatorsCardContainer>
  );
});

export default KeyIndicatorCard;
